/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { buttonWrapperStyle } from "./styles";

import type { FC } from "react";

type Props = {
  children: React.ReactNode;
};

export const ActionButtonArea: FC<Props> = (props) => {
  const { children } = props;

  return <div css={buttonWrapperStyle}>{children}</div>;
};
